import type { FileDownloadStatus } from '@/components/file-download-button/file-download-button.types'

export const DOWNLOADED_STATUS_DURATION_MS = 3000

export const OBJECT_URL_REVOKE_DELAY_MS = 10_000

export const FILE_DOWNLOAD_STATUS_ICONS: Partial<
  Record<FileDownloadStatus, string>
> = {
  downloaded: 'check-small',
  failed: 'close-small',
}
